module.exports = __webpack_public_path__ + "static/media/buy2.199a24f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/buy/buy2.png
// module id = 1095
// module chunks = 0